.infoText {
  padding-bottom: calc(var(--spacer) * 1.5);
}

.form-subtitle {
  margin-top: calc(var(--spacer) * 5.5);
  margin-bottom: calc(var(--spacer) * -1);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
  width: fit-content;
}

#locations-checkbox-form-field {
  margin-top: calc(var(--spacer) * 5.5);
  margin-bottom: calc(var(--spacer) * -3);
}

.section {
  margin-top: calc(var(--spacer) * 4);
}
